import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Icon, { ICON_PROPS } from '../Icon/Icon.js';
import { CommonClasses } from '../../commonClasses.js';

const LINK_PROPS = {
  size: ['xlarge', 'large', 'medium', 'small', 'xsmall', 'tiny', 'inherit'],
  variant: ['default', 'primary', 'secondary', 'danger', 'success']
};
const baseClass = 'nui-link';
const linkPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  external: PropTypes.bool,
  fill: PropTypes.bool,
  iconOnly: PropTypes.bool,
  iconProps: PropTypes.shape({
    fill: PropTypes.oneOf(ICON_PROPS.fill),
    name: PropTypes.string,
    title: PropTypes.string,
    position: PropTypes.string
  }),
  openTab: PropTypes.bool,
  round: PropTypes.bool,
  size: PropTypes.oneOf(LINK_PROPS.size),
  to: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(LINK_PROPS.variant)
};
const Link = /*#__PURE__*/forwardRef(({
  children,
  className,
  external,
  fill = false,
  iconOnly = false,
  iconProps,
  openTab = false,
  round = false,
  size = 'medium',
  to,
  variant = 'default',
  ...otherProps
}, ref) => {
  const sizeClass = `${baseClass}--${size}`;
  const styleClass = `${baseClass}--${variant}`;
  const labelClass = 'nui-button-label';
  const hiddenLabelClass = iconOnly && `${labelClass}--hidden`;
  const iconClass = iconProps && iconProps.name ? 'nui-button--with-icon' : false;
  const iconOnlyClass = iconOnly ? `${iconClass}-only` : false;
  const fillClass = fill && `${baseClass}--fill`;
  const roundClass = round && CommonClasses.ROUND;
  const iconPosition = iconProps && iconProps.position || 'left';
  const classes = cx(baseClass, sizeClass, styleClass, iconClass, iconOnlyClass, fillClass, roundClass, className);
  const linkIcon = iconProps && iconProps.name && /*#__PURE__*/React__default.createElement(Icon, _extends({
    className: `${baseClass}-icon--${iconPosition}`
  }, iconProps, {
    name: iconProps.name
  }));
  const externalProps = external ? {
    target: openTab ? '_blank' : '_self',
    rel: 'noopener noreferrer'
  } : {};
  const renderChildren = () => iconProps ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, iconPosition === 'left' && linkIcon, /*#__PURE__*/React__default.createElement("span", {
    className: cx(labelClass, hiddenLabelClass)
  }, children), iconPosition !== 'left' && linkIcon) : children;
  return /*#__PURE__*/React__default.createElement("a", _extends({
    href: to,
    className: classes
  }, externalProps, otherProps, {
    ref: ref
  }), renderChildren());
});
Link.propTypes = linkPropTypes;
Link.displayName = 'NuiLink';
var Link$1 = Link;

export { LINK_PROPS, baseClass, Link$1 as default };
